import actionTypes from './actionTypes';

const setAppliedReport = (payload) => ({
    type: actionTypes.SET_APPLIED_REPORT,
    payload,
});

const setReportAndFilters = (report, filters) => ({
    type: actionTypes.SET_REPORT_AND_FILTERS,
    report,
    filters,
});

const hydrateAppliedReport = (payload) => ({
    type: actionTypes.HYDRATE_APPLIED_REPORT,
    payload,
});

export default {
    setAppliedReport,
    setReportAndFilters,
    hydrateAppliedReport,
};
